"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var react_1 = __importDefault(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var useListItemStyles = (0, system_1.makeStyles)(function (theme) { return ({
    listItem: __assign({ display: 'flex', minHeight: 48, width: '100%', cursor: 'pointer', borderBottom: '1px solid transparent' }, theme.go.mixins.typography.Body),
    body: __assign(__assign(__assign({ display: 'flex', borderRadius: 16, padding: 6, paddingLeft: 12, alignItems: 'center', flexGrow: 1 }, theme.go.mixins.effects.Hovered('$listItem:hover &')), theme.go.mixins.effects.Pressed('$listItem:active &')), { '$highlighted &': {
            backgroundColor: theme.go.schemes.colors.system.SelectedListItem,
            color: theme.go.schemes.components.lists.selectedTextColor,
        } }),
    content: {
        display: 'flex',
        justifyContent: 'space-between',
        flexGrow: 1,
    },
    subtitleText: __assign(__assign({}, theme.go.mixins.typography.Caption), { color: theme.go.schemes.colors.system.TextMinor, '$highlighted &': {
            color: theme.go.schemes.components.lists.selectedTextMinorColor,
        } }),
    highlighted: {},
    withoutEndSection: {
        paddingRight: 12,
    },
    startSection: {
        display: 'flex',
        alignItems: 'center',
    },
    startElementBox: {
        marginRight: 12,
    },
    endSection: {
        display: 'flex',
        alignItems: 'center',
        color: theme.go.schemes.colors.system.TextMinor,
        '$highlighted &': {
            color: theme.go.schemes.components.lists.selectedTextMinorColor,
        },
        marginLeft: theme.go.schemes.spacing.units.M,
    },
    titlesBox: {
        display: 'flex',
        flexDirection: 'column',
    },
}); });
exports.ListItem = react_1.default.forwardRef(function ListItem(props, ref) {
    var selected = props.selected, classes = props.classes, title = props.title, subtitle = props.subtitle, label = props.label, startElement = props.startElement, endElement = props.endElement, className = props.className, rest = __rest(props, ["selected", "classes", "title", "subtitle", "label", "startElement", "endElement", "className"]);
    var _a = useListItemStyles(), listItem = _a.listItem, body = _a.body, withoutEndSection = _a.withoutEndSection, highlighted = _a.highlighted, startSection = _a.startSection, endSection = _a.endSection, subtitleText = _a.subtitleText, startElementBox = _a.startElementBox, titlesBox = _a.titlesBox, content = _a.content;
    return (react_1.default.createElement("div", __assign({ ref: ref, className: (0, utils_1.cn)(listItem, classes === null || classes === void 0 ? void 0 : classes.listItem, selected ? highlighted : null, className) }, rest),
        react_1.default.createElement("div", { className: (0, utils_1.cn)(body, classes === null || classes === void 0 ? void 0 : classes.body, endElement ? undefined : withoutEndSection) },
            react_1.default.createElement("div", { className: content },
                react_1.default.createElement("div", { className: (0, utils_1.cn)(startSection, classes === null || classes === void 0 ? void 0 : classes.startSection) },
                    startElement ? (react_1.default.createElement("div", { className: startElementBox }, startElement)) : null,
                    react_1.default.createElement("div", { className: titlesBox },
                        title ? react_1.default.createElement("span", null, title) : null,
                        subtitle ? react_1.default.createElement("span", { className: subtitleText }, subtitle) : null)),
                react_1.default.createElement("div", { className: (0, utils_1.cn)(endSection, classes === null || classes === void 0 ? void 0 : classes.endSection) },
                    label ? react_1.default.createElement("span", null, label) : null,
                    endElement || null)))));
});
